module.exports = __webpack_public_path__ + "img/382.92075ff8.jpg";